module.exports = __webpack_public_path__ + "static/media/Logo white.b8ea3e14.png";